import React from "react";

export default function PageHeader({ title, subtitle, actions, testId }) {
  return (
    <div className="flex items-start justify-between mb-8 gap-4" data-testid={testId}>
      <div>
        <h1 className="text-3xl md:text-4xl font-bold tracking-tight text-slate-900" style={{fontFamily:'Outfit'}}>{title}</h1>
        {subtitle && <p className="text-sm text-[var(--hotto-muted)] mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex gap-2">{actions}</div>}
    </div>
  );
}
